'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = require('../config.js');

var Decorator = function Decorator(options) {
  var defaults = {
    color: _config.colors.yellow
  };
  var settings = _extends({}, defaults, options);

  return '\n    &::before {\n      border-top: 3px solid ' + settings.color + ';\n      content: \'\';\n      position: absolute;\n      width: 40px;\n    }\n  ';
};

exports.default = Decorator;